import React, { memo, useState } from 'react';
import { DialogTitle, IconButton, Popover } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const BtnPopoverSmall = (props) => {

    const { title, getIcon, iconMedium } = props;

    const [ anchorEl, setAnchorEl ] = useState(null);

    const closePopover = () => {
      setAnchorEl(null);
    };

    const openPopover = (event) => {
      setAnchorEl(event.currentTarget);
    };

    return (
      <>
        <IconButton onClick={event => openPopover(event)} size={ iconMedium ? 'medium' : 'small'}>
          {getIcon()}
        </IconButton>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={closePopover}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <div className={'btn-popover-small__content'}>
            {title && <DialogTitle className={'btn-popover-small__title'}>
              {title}
            </DialogTitle>}
            <IconButton aria-label="close" onClick={event => closePopover()} size={'small'} className={'btn-popover-small__close'}>
              <CloseIcon fontSize={'small'} />
            </IconButton>

            {props.children}
          </div>
        </Popover>
      </>
    );
  }
;

export default memo(BtnPopoverSmall);
